// export const SERVER = 'http://192.168.1.3:8000'
// export const SERVER = 'http://192.168.90.31:8000'
export const SERVER = 'https://www.globalshielding.app'
